<template>
    <div class="animated fadeIn order-process">
        <b-card class="justify-content-md-center" header="Order sims">
            <b-col cols="12" xl="12" class="order-sims">
                <b-card id="orderAmount" :class="[validationError.ammoutSims ? 'validation-false' : '']">
                    <div v-for="item in itemsList" class="order-sim-number-box">
                        <div class="order-sim-number-left">
                            <img class="carrier-sim" :src="item.cardImage" :alt="item.cardImage">
                            <div class="carrier-logo-box">
                                <img :src="item.lightCarrierImage" :alt="'light logo'" class="carrier-logo light-mode">
                                <img :src="item.darkCarrierImage" :alt="'dark logo'" class="carrier-logo dark-mode">
                            </div>
                            <div class="order-sim-number-input">
                                <input class="order-sim-number" :id="'orderInput' + item.id" @change="changeVolume()" type="number" step="1" pattern="\d*" placeholder="Enter number" min="0" v-model="item.volume" />
                                <button class="control-buttons" v-on:click="removeItem(item)">-</button>
                                <button class="control-buttons action-element" v-on:click="addItem(item)">+</button>
                            </div>
                        </div>
                        <div class="order-sim-number-right">
                            <p>Cost per SIM without Tax <span>$ {{item.unitPrice.toFixed(2)}}</span></p>
                            <strong>Cost: $ {{(item.unitPrice*item.volume).toFixed(2)}}</strong>
                        </div>
                    </div>
                    <div class="total-cost-box">
                        <p>Total cost without Tax: $ {{calculateTotalCost().toFixed(2)}}</p>
                    </div>
                </b-card>
                <b-card id="orderAddress" class="order-address" header="Shipment Address"  :class="[validationError.address ? 'validation-false' : '']">
                    <div class="addres-container">
                        <div v-for="item in shipmentAddreses" :id="'address' + item.id" v-bind:key="item.id" @click="selectShipmentAddress(item.id)" :class="['addres-box', (isShipmentAddressSelected(item.id) ? 'selected' : '')]">
                            <div class="addres-details">
                                <p><strong>{{item.addressName}}</strong></p>
                                <p>{{item.addressLine1}},</p>
                                <p v-if="item.addressLine2">{{item.addressLine2}},</p>
                                <p>{{item.city}},</p>
                                <p>{{item.state}} {{item.postalCode}}, {{item.country}}</p>
                                <p></p>
                            </div>
                            <div class="edit action-element" v-on:click="EditAddres(item.id)">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="new-shipment" v-on:click="newAddres()">
                            <i class="fa fa-plus"></i>
                            <span>New address</span>
                        </div>
                    </div>
                </b-card>
                <b-card v-if="typeAccount == 'PREPAID'" id="orderPayment" header="Payment Method" :class="[validationError.billing ? 'validation-false' : '', 'billing-overview']">
                    <div v-if="creditCards.length" class="credit-cards-list">
                        <div v-for="(card, index) in creditCards" v-bind:key="index" @click="selectCard(card.creditCardId)" :class="['credit-card', (isCardSelected(card.creditCardId)) ? 'selected' : '']">
                            <img class="credit-card-image" :src="require('../../assets/img/' + card.cardImg)" alt="credit-card-logo" />
                            <span class="credit-card-number">{{card.card_desc}}</span>
                            <span class="credit-card-default" v-if="card.defcard == '1'">Default</span>
                        </div>
                    </div>

                    <b-button @click="showModalAddPayment" variant="outline-success" class="add-payment">
                        <i class="fa fa-credit-card-alt" aria-hidden="true"></i> Add <span v-if="creditCards.length">another</span> payment method
                    </b-button>
                </b-card>
                <b-card id="orderShipping" header="Shipping Options" :class="[validationError.shipping ? 'validation-false' : '']">
                    <div class="shipment-methods">
                        <div v-for="(shipment, index) in shippingOptions" :id="'shipping' + shipment.id" v-bind:key="index" @click="selectShipping(shipment.id)" :class="['shipment', (isShippingSelected(shipment.id)) ? 'selected' : '']">
                            <div class="shipment-option">
                                <p class="shipment-option-name">{{shipment.displayName}}</p>
                                <p class="shipment-option-range">{{shipment.range}}</p>
                                <p class="shipment-option-cost">Shipment Cost<span>$ {{shipment.price}}</span></p>
                            </div>
                        </div>
                    </div>
                </b-card>
                <b-card class="transparent-card text-right summary">
                    <button id="orderSimsNextButton" class="btn btn-primary action-element" v-on:click="goToSummary()" >Next</button>
                </b-card>
            </b-col>

            <div class="loader-order-data" v-if="(loading.items || loading.shipmentAddress || loading.shippingOption || loading.payment)">
                <div class="loading-order-data-inner">
                    <div class="sk-wave">
                        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                    </div>

                    <div class="text">
                        Getting order data...
                    </div>
                </div>
            </div>
        </b-card>
        <NewAddres v-if="this.NewAddres" @triggerCloseModalAdd="closeAddModal" />
        <EditAddres v-if="this.editAddres" :sendShipmentData="addresDetails" @triggerCloseModalEdit="closeEditModal" />
        <b-modal id="add-credit-card" size="md" class="user-settings" centered title="Add Credit Card" ref="add-credit-card" hide-footer>
            <div class="user-details">
                <b-row>
                    <b-col md="12">
                        <b-form-group>
                            <label for="cname">Card Nickname</label>
                            <b-form-input type="text" id="cname" v-model="newCard.cardNick" placeholder="Work" v-validate="'required'" data-vv-as="card nick" name="cname"></b-form-input>
                            <span v-show="errors && errors.has('cname')" class="validate-warning">{{ errors.first('cname') }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <div id="card" ref="card"></div>
                    </b-col>

                    <b-col md="12">
                        <b-form-group>
                            <label>Billing Address</label>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group>
                            <label for="address">Address</label>
                            <b-form-input type="text" id="address" placeholder="ex. 23 High St, Apt 5" v-model="newCard.customer.address" v-validate="'required'" name="address"></b-form-input>
                            <span v-show="errors && errors.has('address')" class="validate-warning">{{ errors.first('address') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="city">City</label>
                            <b-form-input type="text" id="city" placeholder="ex. New York" v-model="newCard.customer.city" v-validate="'required'" name="city"></b-form-input>
                            <span v-show="errors && errors.has('city')" class="validate-warning">{{ errors.first('city') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="pstate">State</label>
                            <b-form-input type="text" id="pstate" placeholder="ex. New York" v-model="newCard.customer.state" v-validate="'required'" name="state"></b-form-input>
                            <span v-show="errors && errors.has('state')" class="validate-warning">{{ errors.first('state') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="pzip">ZIP Code</label>
                            <b-form-input type="text" id="pzip" placeholder="ZIP Code" v-model="newCard.customer.zip" v-validate="'required'" name="zip"></b-form-input>
                            <span v-show="errors && errors.has('zip')" class="validate-warning">{{ errors.first('zip') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group class="switch-inline-label">
                            <div>
                                <c-switch class="mx-1" color="success" defaultChecked variant="3d" label v-bind="labelIcon" v-model="newCard.default"/>
                                <label>Set As Default Payment Method</label>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <footer id="add-credit-card___BV_modal_footer_" class="modal-footer">
                <button type="button" class="btn btn-secondary" v-on:click.prevent="hideModalAddPayment">Cancel</button>
                <button type="button" class="btn btn-primary" :disabled="blockAddButton" @click="addCreditCard">Add Credit Card</button>
            </footer>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import globalStore from '../../variables';
    import Axios from 'axios'
    import NewAddres from './NewAddres';
    import EditAddres from './EditAddres';
    import OrderSummary from './OrderSummary';
    import { Switch as cSwitch } from "@coreui/vue";
    import VeeValidate from "vee-validate";
    import {loadStripe} from '@stripe/stripe-js';
    import OrderDetails from "./OrderDetails";
    import VueCookies from 'vue-cookies';
    Vue.use(VueCookies);
    Vue.$cookies.config('7d','','',true)

    const veeValidateConfig = {};

    Vue.use(VeeValidate, veeValidateConfig);

    export default {
        name: "OrderSims",
        components: {
            cSwitch,
            EditAddres,
            NewAddres,
            OrderSummary,
            OrderDetails
        },
        data() {
            return {
                creditCards: [],
                orderId: null,
                validationError: {
                    ammoutSims: false,
                    address: false,
                    billing: false,
                    shipping: false,
                    carrier: false
                },
                isConfirmed: false,
                labelIcon: {
                    dataOn: "\u2713",
                    dataOff: "\u2715"
                },
                firstStep: true,
                secondStep: false,
                thirdStep: false,
                shipmentAddreses: [],
                summaryScreen: false,
                NewAddres: false,
                editAddres: 0,
                editShipmentData: null,
                simsAmount: 0,
                addresDetails: '',
                shippingOptions: null,
                itemsList: [],
                orderData: {
                    shippingOptionId: null,
                    shippingAddressId: null,
                    creditCardId: null,
                    orderItems: []
                },
                newCard: {
                    cardNick: '',
                    cardToken: null,
                    default: false,
                    customer: {
                        address: '',
                        city: '',
                        state: '',
                        zip: '',
                    }
                },
                shippingPrice: null,
                typeAccount: this.$cookies.get('typeAccount'),
                loading: {
                    items: true,
                    payment: true,
                    shipmentAddress: true,
                    shippingOption: true
                },
                carriersAvailable: [],
                blockAddButton: false
            }
        },
        methods: {
            getPriceUnit() {
                Axios.get(globalStore.data.restApiUrl + '/orders/unit-price')
                    .then(response => {
                        this.unitPriceSimon = response.data
                    }).catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Something went wrong',
                            text: 'Error Retrieving Price Details - Contact Support',
                            duration: 3000,
                        });
                    })
            },
            backToOrder() {
                this.secondStep = false;
                this.firstStep = true;
            },
            addCreditCard () {
                this.blockAddButton = true
                let nameCard = this.newCard.cardNick,
                    tempThis = this;

                this.stripe.createToken(this.card, {name: nameCard}).then((result) => {
                    if (result.error) {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Credit Card Error',
                            text: 'Error Processing Credit Card Transaction - Contact Support',
                            duration: 5000,
                        });
                        this.blockAddButton = false
                        console.log(result.error)
                        return false;
                    }
                    tempThis.newCard.cardToken = result.token.id
                    tempThis.saveCardInApi();
                })
            },
            saveCardInApi() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.saveCreditCard()
                    }
                })
            },
            saveCreditCard() {
                Axios.post(globalStore.data.restApiUrl + "/billing/card", this.newCard)
                    .then(response => {
                        this.blockAddButton = false
                        if (response.status == '200') {
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Credit Card added',
                                text: 'New Credit Card Added Successfully',
                                duration: 5000,
                            });
                            this.hideModalAddPayment()
                            this.getCreditCard()
                        }
                    }).catch(error => {
                    this.blockAddButton = false
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Credit Card error',
                            text: 'Error Adding New Credit Card - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            hideModalAddPayment() {
                this.$refs['add-credit-card'].hide();
            },
            showModalAddPayment() {
                this.$refs['add-credit-card'].show();

                let tempThis = this;

                setTimeout(function () {
                    tempThis.card.mount(document.querySelector("#card"))
                }, 100);
            },
            async initStripe() {
                let kindTheme = document.querySelector("body").classList.contains('dark-theme') ? true : false;
                if (globalStore.data.runTimeEnviroment != 'portalsimoniot') {
                    this.stripe = await loadStripe('pk_test_l3Wo58GDAaNzjOR1YAFq679e000GwfPacx');
                } else {
                    this.stripe = await loadStripe('pk_live_68se4hupVyIP7VhdiJCSY0Hw00Cqs6Aifg');
                }
                this.elements = this.stripe.elements();

                if (kindTheme == true) {
                    this.optionsCard = {
                        hidePostalCode: true,
                        metadata: {
                            companyId: 1
                        },
                        style: {
                            base: {
                                color: '#fff',
                                '::placeholder': {
                                    color: 'rgba(255, 255, 255, .6)'
                                },
                            }
                        }
                    }
                } else {
                    this.optionsCard = {
                        hidePostalCode: true,
                        metadata: {
                            companyId: 1
                        }
                    }
                }

                this.card = this.elements.create("card", this.optionsCard);
            },
            getCreditCard() {
                Axios.get(globalStore.data.restApiUrl + '/account/credit-card')
                    .then(response => {
                        this.loading.payment = false;
                        let parse = response.data
                        for (let card of parse) {
                            let cardImg = card.card_desc.substring(0, card.card_desc.indexOf('*'));
                            let cardNum = card.card_desc.substring(card.card_desc.indexOf('*') +5 , card.card_desc.length);
                            if (cardImg == 'Visa') {
                                cardImg = 'Visa-icon.svg'
                            } else if (cardImg == 'MasterCard') {
                                cardImg = 'MasterCard-icon.svg'
                            } else if (cardImg == 'Discover') {
                                cardImg = 'Discover-icon.svg'
                            } else if (cardImg == 'JCB') {
                                cardImg = 'JCB-icon.svg'
                            } else if (cardImg == 'American Express') {
                                cardImg = 'American Express-icon.svg'
                            } else if (cardImg == 'Diners Club') {
                                cardImg = 'dinersclub-icon.svg'
                            } else if (cardImg == 'UnionPay') {
                                cardImg = 'unionpay-icon.svg'
                            } else {
                                cardImg = 'defaultCard-icon.svg'
                            }

                            this.creditCards.push(
                                {
                                    card_desc: card.card_desc,
                                    creditCardId: card.creditCardId,
                                    cardImg: cardImg,
                                    cardNumber: cardNum,
                                    exp_date: card.exp_date,
                                    defcard: card.defcard
                                }
                            )
                        }
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Error',
                            text: 'Error Retrieving Credit Card Details - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            getOptions() {
                Axios.get(globalStore.data.restApiUrl + '/shipping/options')
                    .then(response => {
                        if (response.status == '200') {
                            this.shippingOptions = response.data
                            this.loading.shippingOption = false;
                        }
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Error',
                            text: 'Error Retrieving Shipping Options - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            getAddress() {
                Axios.get(globalStore.data.restApiUrl + '/shipping/all-addresses')
                    .then(response => {
                        this.shipmentAddreses = response.data
                        this.loading.shipmentAddress = false;
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Error',
                            text: 'Error Retrieving Shipping Addresses - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    })

            },
            newAddres() {
                this.NewAddres = true;
            },
            EditAddres(id) {
                this.addresDetails = this.shipmentAddreses.filter(addres => {
                    if (addres.id == id) {
                        return addres
                    }
                })
                this.editAddres = id;
            },

            closeAddModal() {
                this.getAddress()
                this.NewAddres = false;
            },

            closeEditModal() {
                this.getAddress()
                this.editAddres = false;
            },

            filterShipment(id) {
                return this.editAddres
            },
            goToSummary() {

                let anyItems = false
                for (let item of this.itemsList) {
                    if (item.volume > 0) {
                        anyItems = true;
                    }
                }

                if (anyItems) {
                    this.validationError.ammoutSims = false;
                } else {
                    this.validationError.ammoutSims = true;
                    window.scroll(0, document.querySelector("#orderAmount").offsetTop);
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Invalid SIM Quantity',
                        text: 'SIM quantity is Invalid. Quantity must be greater than Zero',
                        duration: 5000,
                    });
                    return false;
                }

                if (this.orderData.shippingAddressId == null) {
                    this.validationError.address = true;
                    window.scroll(0, document.querySelector("#orderAddress").offsetTop);
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Shipping address',
                        text: 'Please Select Shipping Address',
                        duration: 5000,
                    });
                    return false;
                } else {
                    this.validationError.address = false;
                }

                if (this.typeAccount == 'PREPAID' && this.orderData.creditCardId == null) {
                    this.validationError.billing = true;
                    window.scroll(0, document.querySelector("#orderPayment").offsetTop);
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Credit Card',
                        text: 'Please Select Credit Card',
                        duration: 5000,
                    });
                    return false;
                } else if (this.typeAccount == 'OFFLINE_BILLING') {
                    delete this.orderData.creditCardId
                } else {
                    this.validationError.billing = false;
                }

                if (this.orderData.shippingOptionId == null) {
                    this.validationError.shipping = true;
                    window.scroll(0, document.querySelector("#orderShipping").offsetTop);
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Shipping method',
                        text: 'Please Select Shipping Method',
                        duration: 5000,
                    });
                    return false;
                } else {
                    this.validationError.shipping = false;
                }

                let tempThis = this;
                this.shippingPrice = this.shippingOptions.filter(shipment => {
                    if (shipment.id == tempThis.orderData.shippingOptionId) {
                        return shipment
                    }
                })
                this.orderData.orderItems = this.itemsList
                this.$session.set('orderData', this.orderData);
                this.$session.set('itemsList', this.itemsList);
                this.$session.set('priceShipping', this.shippingPrice);
                this.$router.push('/order/sims/order-details');

                // this.firstStep = false;
                // this.secondStep = true;
            },
            addItem(item) {
                item.volume++;
                this.orderData.orderItems = this.itemsList;
                this.calculateTotalCost();
            },
            removeItem(item) {
                if (item.volume){
                    item.volume--;
                }
                this.orderData.orderItems = this.itemsList;
                this.calculateTotalCost();
            },
            changeVolume() {
                for (let item in this.itemsList) {
                    let simVolume = parseInt(this.itemsList[item].volume);
                    this.itemsList[item].volume = simVolume
                }
                this.orderData.orderItems = this.itemsList;
                this.calculateTotalCost();
            },
            calculateTotalCost() {
                let cost = 0;
                for (let item of this.itemsList) {
                    cost = cost + (item.unitPrice * item.volume)
                }
                return cost;
            },
            getCustomerData() {
                Axios.get(globalStore.data.restApiUrl + "/account").then(response => {
                    this.newCard.companyId = response.data.companyId
                })
            },
            selectCard(id) {
                this.orderData.creditCardId = id;
            },
            isCardSelected(id) {
                let selected = false;
                if (this.orderData.creditCardId == id) {
                    selected = true;
                }
                return selected;
            },
            selectShipping(id) {
                this.orderData.shippingOptionId = id;
            },
            isShippingSelected(id) {
                let selected = false;
                if (this.orderData.shippingOptionId == id) {
                    selected = true;
                }
                return selected;
            },
            selectShipmentAddress(id) {
                this.orderData.shippingAddressId = id;
            },
            isShipmentAddressSelected(id) {
                let selected = false;
                if (this.orderData.shippingAddressId == id) {
                    selected = true;
                }
                return selected;
            },
            getItemsData() {
                let simonTypesPermissions = []

                if (this.$cookies.get('simonCarrierAvailable') == 'true' || this.$session.get('simonCarrierAvailable')) {
                    this.carriersAvailable.push(1);
                    simonTypesPermissions.push(4)
                }
                if (this.$cookies.get('tmobileCarrierAvailable') == 'true' || this.$session.get('tmobileCarrierAvailable')) {
                    this.carriersAvailable.push(2);
                }
                if (this.$cookies.get('vodafoneCarrierAvailable') == 'true' || this.$session.get('vodafoneCarrierAvailable')) {
                    this.carriersAvailable.push(3);
                }
                if (this.$cookies.get('koreCarrierAvailable') == 'true' || this.$session.get('koreCarrierAvailable')) {
                    this.carriersAvailable.push(4);
                }

                if (this.$cookies.get('nbIoTPlans') == 'true' || this.$session.get('nbIoTPlans') == true) {
                    simonTypesPermissions.push(5)
                }

                if (this.$cookies.get('catM1Plans') == 'true' || this.$session.get('catM1Plans') == true) {
                    simonTypesPermissions.push(6)
                }

                Axios.get(globalStore.data.restApiUrl + '/orders/items')
                    .then(response => {
                        let list = response.data;
                        let orderedItems = false
                        if(this.$session.get('itemsList')) {
                            orderedItems = this.$session.get('itemsList')
                        }
                        console.log(this.carriersAvailable)

                        for (let item of list) {
                            if (item.inSale && this.carriersAvailable.indexOf(item.carrier.carrierId) > -1) {
                                let tempItem = item;
                                if (orderedItems != false) {
                                    for (let ordered of orderedItems) {
                                        if (tempItem.id == ordered.id) {
                                            tempItem.volume = ordered.volume
                                        }
                                    }
                                } else {
                                    tempItem.volume = 0;
                                }
                                if (item.carrier.carrierId == 1) {
                                    if (simonTypesPermissions.indexOf(item.id) > -1) {
                                        this.itemsList.push(tempItem)
                                    }
                                } else {
                                    this.itemsList.push(tempItem)
                                }
                            }
                        }

                        this.loading.items = false;
                    })
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (from.name != 'OrderDetails') {
                    if (vm.$session.get('orderData')) {
                        vm.$session.remove('orderData')
                    }
                    if (vm.$session.get('itemsList')) {
                        vm.$session.remove('itemsList')
                    }
                    if (vm.$session.get('priceShipping')) {
                        vm.$session.remove('priceShipping')
                    }
                } else if (from.name == 'OrderDetails' && vm.$session.get('orderData')) {
                    vm.orderData.shippingAddressId = vm.$session.get('orderData').shippingAddressId
                    vm.orderData.shippingOptionId = vm.$session.get('orderData').shippingOptionId
                }
            })
        },
        created() {
            this.getItemsData();
            this.getCreditCard();
            this.initStripe();
            this.getOptions();
            this.getAddress();
            this.getCustomerData();
        }
    }
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />

<style lang="scss">

    .card-body {
        position: relative;
        .loader-order-data {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            display: flex;
            justify-content: center;

            background-color: rgba(255, 255, 255, 0.7);

            .loading-order-data-inner {
                margin: 300px 0 0;
            }

            .sk-wave {
                margin: 180px auto 20px;
                height: 60px;
                .sk-rect {
                    width: 3px;
                    background-color: #39c354;
                    border-radius: 4px;
                }
            }

            .text {
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }
        }
    }

    .order-sim-number-box {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }

        .order-sim-number-left {
            display: flex;
            align-items: center;

            .carrier-sim {
                height: 70px;
                width: 110px;
                margin-right: 30px;
            }
            .carrier-logo-box {
                min-width: 225px;
                .carrier-logo {
                    height: 24px;
                    width: auto;

                    &.light-mode {
                        display: block;
                    }
                    &.dark-mode {
                        display: none;
                    }
                }
            }
            .order-sim-number-input{
                display: flex;
                margin-left: 40px;

                .order-sim-number {
                    width: 80px;
                    padding: 6px 6px 6px 20px;
                    border: 1px solid #c9cfd4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                }
                .control-buttons {
                    width: 34px;
                    height: 34px;
                    margin-left: 10px;
                    color: #000000;
                    background-color: #ffffff;
                    border: 1px solid #c9cfd4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                }
            }
        }
        .order-sim-number-right {
            display: flex;
            p {
                margin-right: 20px;
            }
        }
    }

    .order-address {
        .card-body {
            padding-bottom: 0;
        }
    }

    .total-cost-box {
        margin: 20px -20px -20px;
        border-top: 1px solid #c8ced3;
        p {
            padding: 20px;
            margin: 0;
            background-color: #F9F9F9;
            font-weight: 700;
            text-align: right;
        }
    }

    .credit-cards-list {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .credit-card {
            display: flex;
            align-items: center;
            width: 340px;
            margin-bottom: 10px;
            padding: 4px 20px 4px 4px;
            border: 1px solid #C9CFD4;
            -webkit-box-shadow: 0px 3px 6px 3px #eaeaea;
            -moz-box-shadow: 0px 3px 6px 3px #eaeaea;
            box-shadow: 0px 3px 6px 3px #eaeaea;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            cursor: pointer;

            &:hover {
                -webkit-box-shadow: none;
                -moz-box-shadow: none;
                box-shadow: none;
            }

            &.selected {
                border-color: #0088FF;
                -webkit-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                -moz-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
            }

            .credit-card-image {
                margin-right: 11px;
            }

            .credit-card-number {
                margin-right: 20px;
            }

            .credit-card-default {
                flex-grow: 1;
                text-align: right;
            }
        }
    }


    .card-body {
        button.add-payment {
            background-color: #0088ff;
            color: #fff;
            i {
                margin-right: 10px;
            }
            &:hover {
                background-color: #0072cb;
            }
        }
    }
    .shipment-methods {
        display: flex;
        .shipment {
            width: 340px;
            padding: 20px;
            margin-right: 20px;
            border: 1px solid #C9CFD4;
            -webkit-box-shadow: 0px 3px 6px 3px #eaeaea;
            -moz-box-shadow: 0px 3px 6px 3px #eaeaea;
            box-shadow: 0px 3px 6px 3px #eaeaea;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            cursor: pointer;

            span {
                margin-left: 20px;
            }

            &:hover {
                -webkit-box-shadow: none;
                -moz-box-shadow: none;
                box-shadow: none;
            }

            &.selected {
                border-color: #0088FF;
                -webkit-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                -moz-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
            }
            .shipment-option {
                p {
                    margin: 0;
                }
                .shipment-option-name {
                    font-weight: 700;
                }
                .shipment-option-range {
                    color: #c0c2c4;
                }
                .shipment-option-cost {
                    margin-top: 20px;
                }
            }
        }
    }

    .addres-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .new-shipment {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 140px;
            margin-bottom: 20px;
            background-color: #0088ff;
            color: #fff;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            cursor: pointer;
            i {
                font-size: 50px;
            }

            &:hover {
                background-color: #0072cb   ;
            }
        }
        .addres-box {
            width: 300px;
            display: flex;
            flex-direction: row;
            padding: 20px;
            margin-right: 20px;
            margin-bottom: 20px;
            border: 1px solid #C9CFD4;
            -webkit-box-shadow: 0px 3px 6px 3px #eaeaea;
            -moz-box-shadow: 0px 3px 6px 3px #eaeaea;
            box-shadow: 0px 3px 6px 3px #eaeaea;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            cursor: pointer;

            &:hover {
                -webkit-box-shadow: none;
                -moz-box-shadow: none;
                box-shadow: none;
            }

            &.selected {
                border-color: #0088FF;
                -webkit-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                -moz-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
            }

            .icon-select {
                margin-right: 20px;
            }

            .addres-details {
                flex-grow: 1;
                p {
                    margin: 0 auto;
                }
            }

            .edit {
                min-width: 0;
                cursor: pointer;
                i {
                    color: #0088ff;
                    padding: 3px;
                    -webkit-border-radius: 3px;
                    -moz-border-radius: 3px;
                    border-radius: 3px;
                    &:hover {
                        background-color: #0088ff;
                        color: #fff;
                    }
                }
            }

            @media (min-width: 1200px) and (max-width: 1600px) {
                max-width: none;
                margin-left: 0;
                margin-right: 0;
            }
        }
    }

.StripeElement {
    margin-bottom: 20px;
    padding: 10px;
    border-radius: 5px;
    background-color: #f0f3f5;
    border: 1px solid #C9CFD4;
}

#add-credit-card___BV_modal_footer_ {
    padding: 0;
}



    .select-carrier {
        .select-carrier-box {
            display: flex;
            justify-content: space-around;
            width: 100%;
            margin: 0 auto;
            .carrier-option {
                display: flex;
                align-items: center;
                input {
                    display: none;
                    cursor: pointer;
                }
                label {
                    width: 220px;
                    padding: 14px 20px;
                    margin-left: 20px;
                    border: 2px solid #a8acb1;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    opacity: 0.3;
                    cursor: pointer;
                    img {
                        margin: 0 auto;
                    }
                    .light-mode {
                        display: block;
                    }
                    .dark-mode {
                        display: none;
                    }
                }
                input[type="radio"]:checked + label {
                    opacity: 1;
                }
            }
        }
    }



    .dark-theme {
        .card-body {
            .loader-order-data {
                background-color: rgba(0, 0, 0, 0.4);
            }
        }
        .order-sim-number-box {
            .order-sim-number-left {
                .carrier-logo-box {
                    .carrier-logo {
                        &.light-mode {
                            display: none;
                        }

                        &.dark-mode {
                            display: block;
                        }
                    }
                }
            }

            .order-sim-number-left {
                .order-sim-number-input {
                    .order-sim-number {
                        border-color: #1a1c1d;
                    }
                    .control-buttons {
                        color: #edeeef;
                        background-color: #515b65;
                        border-color: #1a1c1d;
                    }
                }
            }
        }

        .order-sim-number,
        .control-buttons,
        .addres-box-inner,
        .btn-light {
            background-color: #515b65;
            border-color: #1a1c1d;
            color: #EDEEEF;
        }

        .total-cost-box {
            border-color: #1a1c1d;
            p {
                background-color: #2e343a;
            }
        }

        .addres-container {
            .addres-box {
                border-color: #1a1c1d;
                -webkit-box-shadow: 0px 3px 6px 3px #353B43;
                box-shadow: 0px 3px 6px 3px #353B43;
                &:hover {
                    -webkit-box-shadow: none;
                    box-shadow: none;
                }

                &.selected {
                    border-color: #0088FF;
                    -webkit-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    -moz-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                }

                .addres-box-inner {
                    background-color: #515b65;
                    border-color: #1a1c1d;
                }
            }
            .new-shipment {
                .btn-light{
                    border-color: #55cd6c;
                }
            }
        }

        .credit-cards-list {
            .credit-card {
                border-color: #1a1c1d;
                -webkit-box-shadow: 0px 3px 6px 3px #353B43;
                box-shadow: 0px 3px 6px 3px #353B43;
                &:hover {
                    -webkit-box-shadow: none;
                    box-shadow: none;
                }

                &.selected {
                    border-color: #0088FF;
                    -webkit-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    -moz-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                }
            }
        }

        .shipment-methods {
            .shipment {
                border-color: #1a1c1d;
                -webkit-box-shadow: 0px 3px 6px 3px #353B43;
                box-shadow: 0px 3px 6px 3px #353B43;
                &:hover {
                    -webkit-box-shadow: none;
                    box-shadow: none;
                }

                &.selected {
                    border-color: #0088FF;
                    -webkit-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    -moz-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                }
                .card-wrap {
                    background: #515b65;
                    .cost {
                        border-color: #3a4149;
                    }
                }
            }
        }

        .btn-outline-success {
            background-color: #515b65;
            color: #EDEEEF;
            &:hover {
                background-color: #55cd6c;
            }
        }

        .container-fluid {
            .summary {
                background-color: transparent;
                border-color: #2f353a;
                border: none;
                .card-body {
                    background-color: transparent;
                }
            }
        }

        .payment-item {
            background-color: #3a4149;
        }

        #add-credit-card {
            .modal-content {
                background-color: #3a4149;

                .user-details {
                    color: #EDEEEF;
                }

                .modal-title,
                .close {
                    color: #EDEEEF;
                }

                select,
                input {
                    background-color: #2f353a;
                    border-color: #171a1e;
                    color: #EDEEEF;
                    &::placeholder {
                        color: #EDEEEF;
                    }
                }

                .StripeElement {
                    background-color: #2f353a;
                    border-color: #171a1e;
                    .ElementsApp {
                        input {
                            color: #EDEEEF;
                        }
                    }
                }
            }
        }
    }
</style>
